import { useLanguage } from "@/i18n/LanguageContext";

/** Fingletek developer credit — phone is Fingletek contact, not Academy. */
export const FINGLETEK_SITE = "https://www.fingletek.com/";
export const FINGLETEK_PHONE_TEL = "tel:+358440685538";

export function FingletekCredit() {
  const { t } = useLanguage();

  return (
    <p className="dn-footer-credit">
      <span className="dn-footer-credit-line">
        {t.common.poweredBy}{" "}
        <a href={FINGLETEK_SITE} target="_blank" rel="noopener noreferrer">
          Fingletek
        </a>
      </span>
      <span className="dn-footer-credit-sep" aria-hidden="true">
        ·
      </span>
      <a className="dn-footer-phone" href={FINGLETEK_PHONE_TEL}>
        {t.common.fingletekPhone}
      </a>
    </p>
  );
}
